import { LogOut } from 'lucide-react';
import { IonicButton } from 'ionic-ui';
import React from 'react';
import useSignOut from '../../../../services/authentication/hooks/useSignOut';

export default function SignOutAccountCard() {
  const { requestSignOut } = useSignOut();
  return (
    <div className="border border-border rounded-md p-4 space-y-4">
      <h6 className="font-bold high-emphasis-text">Sign Out</h6>
      <p className="medium-emphasis-text">
        Sign out of your account on this device.
      </p>

      {/* DIVIDER */}
      <div className="w-full h-[1px] rounded-sm bg-border"></div>

      <IonicButton
        variant="outline"
        className="button-with-icon"
        type="button"
        onClick={requestSignOut}
      >
        <LogOut />
        <span>Sign Out</span>
      </IonicButton>
    </div>
  );
}
